module.exports = __webpack_public_path__ + "30cf87d02b9440106cc8b913cc62a69f.svg";